import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { fetchServiceRequestTags } from "../../../../../store/actions/formOptions";


export const TagFilter = ({
  tags,
  setTags
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchServiceRequestTags());
  }, [dispatch]);

  const serviceRequestTags = useSelector(
    (state) => state.formOptions.serviceRequestTags || []
  );
  return (
    <>
      <div className="filters-modal__label">{"Tags"}</div>
        <div style={{ marginBottom: 20 }}>
          <Select
            menuPlacement="top"
            placeholder="Select Tags"
            closeMenuOnSelect={false}
            isClearable
            isMulti
            options={
              serviceRequestTags.length > 0
                ? serviceRequestTags.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
                : []
            }
            value={tags}
            onChange={(newValue) => setTags(newValue)}
          />
        </div>
    </>
  )
}